import { AuthenticationService } from '@absg/angular-platform';
import { IdentityApi } from '@absg/api-identity';
import { NimAlertService, PartyService, SessionService } from '@absg/nim-client-shared';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StationAuthenticationService } from 'core.services/station-authentication.service';
import { Observable, Subscription } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';
import { ContentPage } from 'shared.components/content-page/content-page';

@Component({
  selector: '[nc-legal-disclaimer]',
  templateUrl: './legal-disclaimer.component.html',
  standalone: false,
})
export class LegalDisclaimerComponent extends ContentPage implements OnInit, OnDestroy {
  private readonly disclaimerAccepted = '1';
  disclaimerText: Observable<string>;
  showSearchSpinner = false;
  userLegalSubscription: Subscription;
  counter: number;
  agreeBtnDisabled = false;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private sessionService: SessionService,
    private partyService: PartyService,
    private nimAlertService: NimAlertService,
    private activatedRoute: ActivatedRoute,
    private identityApi: IdentityApi,
    private stationAuthenticationService: StationAuthenticationService,
  ) {
    super();
  }

  updatePasswordResetRequiredFlag(): void {
    this.setComponentSpinner(true);
    this.partyService.updatePasswordResetRequiredFlag()
      .pipe(
        take(1),
        finalize(() => this.setComponentSpinner(false)),
      )
      .subscribe(response => {
        if (!response) {
          this.onSavePasswordResetFlagFailure();
        }
      },
        () => { this.onSavePasswordResetFlagFailure(); },
      );
  }

  onSave(): void {
    this.counter = 0;
    this.agreeBtnDisabled = true;
    this.setComponentSpinner(true);
    this.partyService.saveLegalDisclaimerAcceptance(this.disclaimerAccepted)
      .pipe(take(1))
      .subscribe(response => {
        if (response && response.userAcceptedLegalDisclaimer === this.disclaimerAccepted) {
          this.checkLegalDisclaimerUpdate();
        } else {
          this.onSaveLegalDisclaimerAcceptanceFailure();
        }
      },
        () => { this.onSaveLegalDisclaimerAcceptanceFailure(); });
  }

  onSavePasswordResetFlagFailure(): void {
    this.nimAlertService.showErrorAlert('Error Saving Data.', new Error('Password reset policy could not be saved.'));
  }

  onSaveLegalDisclaimerAcceptanceSuccess(): void {
    this.authenticationService.resetLegalDisclaimerAcceptedStatus();
    this.sessionService.setHasUserAcceptedLegalDisclaimer();

    this.redirectToDispense();
  }

  onSaveLegalDisclaimerAcceptanceFailure(): void {
    this.setComponentSpinner(false);
    this.nimAlertService.showErrorAlert('Error Saving Data.', new Error('Legal Disclaimer Acceptance could not be saved.'));
    this.logout();
  }

  onCancelClicked(): void {
    this.logout();
  }

  private logout(): void {
    this.stationAuthenticationService.redirectToLogoutPage().pipe(
      take(1),
    ).subscribe();
  }

  ngOnInit(): void {
    this.updatePasswordResetRequiredFlag();
    this.getLegalDisclaimerText();
  }

  ngOnDestroy(): void {
    if (this.userLegalSubscription) {
      this.userLegalSubscription.unsubscribe();
    }
  }

  getLegalDisclaimerText(): void {
    this.disclaimerText = this.activatedRoute.data
      .pipe(
        take(1),
        map((data) => data.result),
      );
  }

  setComponentSpinner(show: boolean): void {
    this.showSearchSpinner = show;
  }

  checkLegalDisclaimerUpdate(): void {
    this.setComponentSpinner(true);
    this.counter = this.counter + 1;
    const isAcceptLegalDisclaimer = 1;
    const fixedNumberofRetry = 20;
    let timeInterval = 500;
    this.userLegalSubscription = this.identityApi.getUserLegalDisclaimer()
      .subscribe(response => {
        if (response && (response !== null) && response === isAcceptLegalDisclaimer) {
          this.onSaveLegalDisclaimerAcceptanceSuccess();
        } else {
          timeInterval = timeInterval * this.counter;
          if (this.counter <= fixedNumberofRetry) {
            setTimeout(() => {
              this.checkLegalDisclaimerUpdate();
            }, timeInterval);
          } else {
            this.setComponentSpinner(false);
            this.onSaveLegalDisclaimerAcceptanceFailure();
          }
        }
      },
        () => {
          this.onSaveLegalDisclaimerAcceptanceFailure();
        },
      );
  }

  private redirectToDispense(): void {
    this.router.navigate(['/dispense']);
  }
}
